import './product-details.scss';

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const productDetailPage = isProductDetailPage; // eslint-disable-line

        if (productDetailPage) {
            if (typeof window.ga !== 'undefined') {
                window.ga('send', 'event', 'product_detail_page', 'pageview', window.location.pathname);
                console.info('send', 'event', 'product_detail_page', 'pageview', window.location.pathname);
            }
        }
    }
});
